import { render, staticRenderFns } from "./roleSelect.vue?vue&type=template&id=4820e7b1&scoped=true&"
import script from "./roleSelect.vue?vue&type=script&lang=js&"
export * from "./roleSelect.vue?vue&type=script&lang=js&"
import style0 from "./roleSelect.vue?vue&type=style&index=0&id=4820e7b1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4820e7b1",
  null
  
)

export default component.exports